module.exports = __webpack_public_path__ + "static/media/037.66ba7079.jpg";